import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body pb-2" }
const _hoisted_3 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "Alergia",
    modelValue: _ctx.dialogAlergy,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialogAlergy) = $event)),
    draggable: "",
    class: "bg-light rounded w-100 w-md-500px",
    onOpen: _ctx.onOpen,
    onClosed: _ctx.onClosed
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "danger",
          text: "",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogAlergy = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancelar")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submitForm(_ctx.formRef))),
          loading: _ctx.loader
        }, {
          default: _withCtx(() => [
            _createTextVNode("Guardar")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form, {
            ref: "formRef",
            model: _ctx.formData,
            rules: _ctx.rules,
            class: "form form-label-right",
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "Alergia",
                prop: "idallergy",
                rules: [{
                        required: true,
                        message: 'Campo requerido',
                        trigger: ['blur', 'change'],
                    }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.formData.idallergy,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.idallergy) = $event)),
                    "value-key": "id",
                    class: "w-100",
                    placeholder: "- Seleccione -"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listAllergy, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          value: item,
                          label: item.name
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Severidad",
                prop: "idseverity",
                rules: [{
                        required: true,
                        message: 'Campo requerido',
                        trigger: ['blur', 'change'],
                    }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.formData.idseverity,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.idseverity) = $event)),
                    "value-key": "id",
                    class: "w-100",
                    placeholder: "- Seleccione -"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSeverity, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          value: item,
                          label: item.name
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Reacciones",
                prop: "reactions"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.reactions,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.reactions) = $event)),
                    type: "textarea"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onOpen", "onClosed"]))
}